<template>
  <div class="float-right">
    <img
      src="../../assets/images2.0/forum/flag-solid.svg"
      height="16"
      title="This post has ben reported..Please make changes to the post"
      alt="reported icon"
    />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
